import {
  type TStatuses,
  type Value,
} from 'infrastructure/interfaces/i-rpm-patient-activity';
import { ReadingStatus } from 'infrastructure/enums/reading-statuses';
import {
  type CcmStatuses,
  type ReadingType,
  type RpmStatuses,
} from 'infrastructure/enums';
import { type IPatientThresholds } from 'infrastructure/interfaces';

export interface IPatientReadingAlert {
  id: string;
  patientGuid: string;
  patientFirstName: string;
  patientLastName: string;
  birthDate: string;
  language: string;
  doctorFirstName: string;
  doctorLastName: string;
  doctorTitle: string;
  globalStatus: ReadingStatus;
  dateTime: number;
  createdAt: number;
  readingType: ReadingType;
  statuses: TStatuses;
  value: Value;
  status: RpmStatuses;
  ccmStatus: CcmStatuses;
  thresholds: IPatientThresholds;
  doNotCall?: boolean;
  thresholdName?: string;
  deviceId?: string;
}

export type TPatientAlertFilter = 'all' | 'critical' | 'risk' | 'normal';

export const alertStatusLabel: Record<ReadingStatus, string> = {
  [ReadingStatus.Critical]: 'CRITICAL',
  [ReadingStatus.Risk]: 'AT RISK',
  [ReadingStatus.Normal]: 'NORMAL',
};
